<template>
    <div>
        <FlexLoader v-if="requestIsLoading"/>
        <a ref="openBasicModal" class="btn btn-sm btn-primary transition-3d-hover" href="#basicModal"
           data-modal-target="#basicModal" hidden>
            Open basic modal
        </a>
        <BasicModal :title="modal.title" :text="modal.text" :next="modal.next"/>

        <script type="application/javascript" v-bind:src="hsCoreSrc"></script>
        <script type="application/javascript" v-bind:src="hsModalWindowSrc"></script>
        <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
    </div>
</template>

<script>
    import {ACTIVATE_ACCOUNT} from "../../settings/graphql";
    import {JS_FILES} from "../../settings/scripts";
    import BasicModal from "../../components/BasicModal";
    import FlexLoader from "../../components/FlexLoader";
    import {errorMessageDisplay} from "../../xlib/graphql";

    export default {
        name: "Activate",
        components: {FlexLoader, BasicModal},
        data() {
            return {
                requestIsLoading: true,
                modal: {
                    text: "",
                    title: "",
                    next: ""
                },
                hsCoreSrc: JS_FILES.hs.core,
                hsModalWindowSrc: JS_FILES.hs.modalWindow,
                hsPluginsInitSrc: JS_FILES.hs.pluginsInit.modalWindow
            }
        },
        mounted() {
            this.activate_account()
        },
        methods: {
            activate_account() {
                const uid = this.$route.params.uid;
                const token = this.$route.params.token;
                this.$apollo.mutate({
                    mutation: ACTIVATE_ACCOUNT,
                    variables: {uid, token}
                }).then(() => {
                    // console.log(`Account successfully activated : ${JSON.stringify(data)}`);
                    this.$data.requestIsLoading = false;
                    this.$data.modal = {
                        title: "Activation réussie",
                        text: "Votre compte a été activé avec succès",
                        next: 'login'
                    };
                    this.$refs.openBasicModal.click();
                }).catch((error) => {
                    // console.error(`Error on account activation: ${JSON.stringify(error)}`);
                    this.$data.requestIsLoading = false;
                    this.$data.error = errorMessageDisplay(error);
                });
            }
        }
    }
</script>

<style scoped>

</style>